export const isLocal = () => {
  // Check if running on localhost with any port
  return window.location.hostname === 'localhost';
};

export const isDev = () => {
  return window.location.host === 'dev.app.in-pool.ch';
};

export const isProd = () => {
  return (
    window.location.host === 'app.in-pool.ch' ||
    window.location.host === 'old.app.in-pool.ch'
  );
};

export const isDemo = () => {
  return window.location.host === 'demo.app.in-pool.ch';
};

export const isStaging = () => {
  return window.location.host === 'staging.app.in-pool.ch';
};
